import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const FaqsServices = createApi({
	reducerPath: "FaqsServices",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			faqsContent: builder.query({
				query: () => {
					return {
						url: "faqs",
						method: "GET",
					};
				},
			}),
			termContent: builder.query({
				query: () => {
					return {
						url: "pages/terms-and-conditions",
						method: "GET",
					};
				},
			}),
			privacyContent: builder.query({
				query: () => {
					return {
						url: "pages/privacy-policy",
						method: "GET",
					};
				},
			}),
			benefitsContent: builder.query({
				query: () => {
					return {
						url: "/benefits",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const {
	useFaqsContentQuery,
	useTermContentQuery,
	usePrivacyContentQuery,
	useBenefitsContentQuery,
} = FaqsServices;
export default FaqsServices;
